import * as am4charts from '@amcharts/amcharts4/charts';
import moment from 'moment';
import { IBatteryLevelData } from './batteryLevelChart';
import { TTypedTFunction } from '@lib/useTypedTranslation';
import { formatDate } from '../../core/device/compositions/performance/charts/deviceChargeLevel';

export function drawXAxisLabels(xAxis: am4charts.DateAxis, date: number) {
  xAxis.dataFields.data = "local";
  xAxis.min = moment(date).utc().startOf('day').valueOf();
  xAxis.max = moment(date).utc().endOf('day').valueOf();

  xAxis.dateFormatter.utc = true;
  xAxis.dateFormats.setKey("day", "dt");
  xAxis.markUnitChange = false;
  xAxis.renderer.labels.template.disabled = false;
  xAxis.renderer.labels.template.location = 0.001 as any;
  xAxis.baseInterval = { timeUnit: "second", count: 1 };
  xAxis.gridIntervals.setAll([
    { timeUnit: "hour", count: 1 },
    { timeUnit: "hour", count: 3 },
    { timeUnit: "hour", count: 6 }
  ]);
}

export function drawYAxisLabelsLineChart(yAxis: am4charts.ValueAxis) {
  yAxis.min = 0;
  yAxis.max = 100;
  yAxis.strictMinMax = true;
  yAxis.renderer.minGridDistance = 30;
  yAxis.numberFormatter.numberFormat = "#'%'";
  yAxis.cursorTooltipEnabled = false;
  yAxis.contentAlign = 'right';
  yAxis.renderer.grid.template.disabled = false;
  yAxis.renderer.labels.template.disabled = true;
  yAxis.axisRanges.clear();
  createGrid(0, yAxis);
  createGrid(25, yAxis);
  createGrid(50, yAxis);
  createGrid(75, yAxis);
  createGrid(100, yAxis);
}

export function sortByDate(data: Array<any>): Array<any> {
  return data?.sort((a: any, b: any) => a.local - b.local);
}

export function getData(data: IBatteryLevelData[]): Array<any> {
  if (!data.length) {
    return [];
  }
  return sortByDate(data).map((item: any) => {
    return {
      local: parseInt(item.local),
      level: item.level,
      deviceSerialNumber: item.device?.serialNumber ?? '-'
    };
  });
}

export function createGrid(value: number, yAxis: am4charts.ValueAxis): void {
  let range = yAxis.axisRanges.create();
  range.label = new am4charts.AxisLabel();
  range.label.dy = -18;
  range.value = value;
  range.label.text = "{value}";
}

export const getTooltipAdapter = (t: TTypedTFunction) => {
  return (_: any, target: am4charts.LineSeries) => {
    const tooltip = target.tooltipDataItem as any;
    const date = formatDate(tooltip.dateX);
    const colour = target?.dummyData?.colour;
    return `<div class="tooltip-container_device-charge-level"><span class="device-charge-level-24-hour-tooltip-title">${date}</span>
    </br><span class="line-chart-tooltip-container_device-charge-level"><div class="key" style="--colour: ${colour}"></div>${t('CHARGE_LEVEL')}: {valueY}</span>
    </br><span class="line-chart-tooltip-container-tooltip-text serialnumber">${t('DEVICE', { ns: 'translation' })} SN: ${tooltip.dataContext?.deviceSerialNumber}</span></div>`;
  };
};
